import React, { useEffect } from "react";

const TopicsBtn = (props) => {
  return (
    <a style={{ textDecoration: "none", color: "black" }} href={`/category/${props.topic}`}>
      <div className="topic_btn">
        <p>{props.topic}</p>
      </div>
    </a>
  );
};

const TopicList = () => {
  return (
    <div className="search_div cards_div mb_4rem mt_4rem">
      <p className="tgrey fs20px">
        <i class="fas fa-search"></i> Search topics
      </p>
      <div className="d-flex topic_scroll_x">
        <TopicsBtn topic="GST" />
        <TopicsBtn topic="TAX" />
        <TopicsBtn topic="FINANCE" />
        <TopicsBtn topic="ACCOUNTS" />
        <TopicsBtn topic="STARTUP" />
      </div>
      <i class="fas fa-arrow-right fr"></i>
    </div>
  );
};
export default TopicList;
